import React from "react";

const Card = ({
  children,
  className = "",
  hover = true,
  variant = "light",
  noShadow = false,
  glass = false,
}) => {
  const variants = {
    light: "bg-white border border-gray-100/50 text-gray-900",
    dark: "bg-gradient-to-br from-gray-900 to-gray-800 border border-gray-700/50 text-white",
    glass: "bg-white/80 backdrop-blur-xl border border-white/20 text-gray-900 shadow-glass",
  };

  const shadowClass = glass
    ? ""
    : noShadow
    ? ""
    : variant === "glass"
    ? "shadow-glass"
    : "shadow-soft";

  return (
    <div
      className={`rounded-2xl ${shadowClass} p-6 sm:p-8 ${
        variants[variant]
      } ${
        hover
          ? `transition-all duration-300 ${
              noShadow && !glass ? "" : "hover:shadow-large"
            } hover:-translate-y-1 hover:scale-[1.02]`
          : ""
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
